// ============================================================================
// text-sanitize.js — stripJuristic
// ------------------------------------------------------------
// ตัดคำว่า "นิติบุคคล" (และคำสะกดผิด "นิติบุคล") ออกจากข้อความที่ "แสดงผลอย่างเดียว"
// ฝั่ง admin (หัวข้อ / preview / label / ชื่อในลิสต์)
// ★ ห้ามใช้กับ value ของช่อง input ที่แอดมินแก้ไข/กดบันทึกได้ — ค่าที่เก็บใน DB
//   และค่าที่ส่งมาจาก API ต้องไม่เปลี่ยน ถ้าตัดคำแล้วนำไปบันทึกจะทับข้อมูลจริง
//
// นอกจากตัดคำแล้วยังเก็บกวาดผลข้างเคียงให้อ่านรู้เรื่อง:
//   - ช่องว่างซ้อน / ช่องว่างหัวท้ายที่เหลือจากการตัดคำ
//   - คำเชื่อมที่ค้างท้ายกลุ่มอักษรเดิม (จาก/ของ/กับ/โดย/คือ/เป็น) เช่น
//     "ข้อมูลตรงจากนิติบุคคล ตรวจสอบ..." ตัดคำแล้วเหลือ "ข้อมูลตรงจาก ตรวจสอบ..."
//     ซึ่งอ่านไม่รู้เรื่อง จึงต้องตัด "จาก" ที่ค้างออกด้วย เหลือ "ข้อมูลตรง ตรวจสอบ..."
// ============================================================================

const JURISTIC_WORDS = ["นิติบุคคล", "นิติบุคล"];

// คำเชื่อมที่มักอยู่ติดหน้าคำว่า "นิติบุคคล" แบบไม่มีช่องว่างคั่น (ภาษาไทยไม่เว้นวรรคระหว่างคำในประโยคเดียวกัน)
// พอตัดคำออกแล้วคำเชื่อมพวกนี้จะค้างอยู่ท้ายกลุ่มอักษรเดิม ต้องตัดทิ้งไปด้วย
const DANGLING_PREFIXES = ["จาก", "ของ", "กับ", "โดย", "คือ", "เป็น"];

export const stripJuristic = (input) => {
    if (typeof input !== "string" || !input) return input;

    let result = input;
    let changed = false;
    for (const word of JURISTIC_WORDS) {
        if (!result.includes(word)) continue;
        result = result.split(word).join("");
        changed = true;
    }

    if (!changed) return input;

    // เก็บกวาดคำเชื่อมที่ค้างท้ายกลุ่มอักษร (แบ่งกลุ่มด้วยช่องว่าง แต่เก็บช่องว่างไว้ประกอบกลับ)
    result = result
        .split(/(\s+)/)
        .map((chunk) => {
            if (!chunk || !chunk.trim()) return chunk; // ช่องว่างล้วน ปล่อยผ่าน
            for (const prefix of DANGLING_PREFIXES) {
                if (chunk === prefix) return ""; // ทั้งกลุ่มเป็นคำเชื่อมล้วน ๆ ตัดทิ้งทั้งกลุ่ม
                if (chunk.length > prefix.length && chunk.endsWith(prefix)) {
                    return chunk.slice(0, -prefix.length);
                }
            }
            return chunk;
        })
        .join("");

    // ช่องว่างซ้อน / ช่องว่างหัวท้ายที่เหลือ
    return result.replace(/[ \t]+/g, " ").trim();
};

export default stripJuristic;
